function Emitter () {
  this.mutations = {}
}

Emitter.prototype.emit = function (name, args) {
  for (let mutation in this.mutations) {
    if (mutation === name) {
      return new Promise((resolve, reject) => {
        this.mutations[mutation](args)
        resolve()
      })
    }
  }
  throw new Error(`sorry, Action not found ${name}.`)
}

Emitter.prototype.on = function (name, cb) {
  if (cb && typeof cb === 'function') {
    this.mutations[name] = cb
  }
}

export default Emitter



// WEBPACK FOOTER //
// ./src/components/framework/uploader/common/emitter.js